import { Grid, Filter, Page, Sort, RecordClickEventArgs, Edit, Toolbar } from '@syncfusion/ej2-grids';
import { Query, DataManager, WebApiAdaptor } from '@syncfusion/ej2-data';
import { DateHelper } from '../../Helpers/DateHelper';
import { DropDownList, ChangeEventArgs } from '@syncfusion/ej2-dropdowns';
import { DatePicker, DateTimePicker } from '@syncfusion/ej2-calendars';
import { ConfirmModal } from '../../Helpers/ConfirmModal';
import { LookupDataService } from '../../DataService/LookupDataService';


export class CustomerArticleCrossReferencesManager {

    constructor(private containerElement: JQuery) { }

    private articleCrossReferencesGrid : Grid;
    private removeWithoutConfirmingCheckbox : JQuery<HTMLElement>;
    

    public initialize() {
        var self = this;

        var erpCustomerId = self.containerElement.children().first().data('erp-customer-id');
        self.removeWithoutConfirmingCheckbox = self.containerElement.find('#remove-xref-without-confirming-checkbox');

        Grid.Inject(Edit, Toolbar, Filter, Page, Sort);


        let articleCrossReferenceData: DataManager = new DataManager({
            url: `/api/company/lookup/erp/customer/${erpCustomerId}/article-cross-references`,
            adaptor: new WebApiAdaptor
        });

        var creationDateElem;
        var creationDateObj;

        var columns : any = [
            { field: 'Id', isPrimaryKey: true, visible: false, allowEditing: false, validationRules: { required: true }},    
            { field: 'CreationDateTimeString', headerText: 'Creation date', autoFit: true, allowEditing: false, width: '150px', validationRules: { required: true },
                filterBarTemplate: {
                    create: () => { 
                            creationDateElem = document.createElement('input'); 
                            return creationDateElem; 
                    }, 
                    write: (args) => { 
                        creationDateObj = new DatePicker({ 
                            value: new Date(args.column.field), 
                            format: "dd-MM-yyyy",
                            floatLabelType: 'Never', 
                            change: (args) => {
                                var dateValue = DateHelper.DateToString(args.value);
                                if(dateValue == undefined) {
                                    self.articleCrossReferencesGrid.removeFilteredColsByField("CreationDateTimeString");
                                }
                                else {
                                    self.articleCrossReferencesGrid.filterByColumn("CreationDateTimeString", 'equal', dateValue, undefined, true);
                                }
                            }
                        }); 
                        creationDateObj.appendTo(creationDateElem); 
                    } 
                }
            }, 
            { field: 'CustomerArticleDescription', headerText: 'Customer description', autoFit: true, validationRules: { required: false }},
            { field: 'Catalog', headerText: 'XREF catalog', width: '125px', autoFit: true, validationRules: { required: false }},
            { field: 'CatalogArticleCode', headerText: 'XREF art. code', width: '125px', autoFit: true, validationRules: { required: false }},
            { field: 'CatalogArticleDescription', headerText: 'XREF article description', autoFit: true, validationRules: { required: false }},

            { field: 'ExtraActions', headerText: '', allowFiltering: false, allowEditing: false, autoFit: true, width: '75px', textAlign: 'Right', template: '${getCustomerArticleCrossReferencesExtraActions(data.Id)}' }
        ];

        self.articleCrossReferencesGrid = new Grid(
        {
            height: '100%',
            dataSource: articleCrossReferenceData,
            editSettings: { allowEditing: true, allowAdding: false, allowDeleting: false, mode: 'Normal', newRowPosition: 'Top' },
            columns: columns,
            allowSorting: true,
            allowPaging: true,
            allowFiltering: true,
            allowSelection: false,
            pageSettings: { pageSize: 100 },
            // toolbar: ['Update', 'Cancel'],
            //actionComplete: actionComplete,
            created: () => {
                // erpContentElement = erpContentElement.find('.e-content')

                // loadingContainer.addClass('d-none');
                // customerCrossReferencesContainer.removeClass('d-none');

            },
            recordClick: (args: RecordClickEventArgs) => {
                if (args.target != undefined && args.rowData != undefined) {
                    var parsedTarget = $(args.target); 
                    var erpCustomerArticleCrossReferenceId = args.rowData["Id"];

                    if(parsedTarget.data('action') == 'remove-customer-article-xref' || parsedTarget.parent().data('action') == 'remove-customer-article-xref' && erpCustomerArticleCrossReferenceId != undefined) {
                        var targetButton = parsedTarget;
                        if(parsedTarget.is('i')) {
                            targetButton = parsedTarget.parent();
                        }

                        targetButton.prop('disabled', true);

                        var removeCustomerArticleCrossReference = () => {
                            LookupDataService.removeCustomerArticleCrossReference(erpCustomerId, erpCustomerArticleCrossReferenceId, (result) => {
                                if(result == true) {
                                    args.row?.remove();
                                }
                            })
                        }

                        if(self.removeWithoutConfirmingCheckbox.is(':checked')) {
                            removeCustomerArticleCrossReference();
                        }
                        else {
                            new ConfirmModal().initialize('Remove article cross reference', 'Are you sure you want to remove this cross reference?</br>This action cannot be reverted.', () => {
                                removeCustomerArticleCrossReference();
                            }, () => {
                                targetButton.prop('disabled', false);
                            }, 'Confirm', 'Cancel')     
                        }
                    }
                }
            },
        });

        self.articleCrossReferencesGrid.appendTo('#article-cross-references-grid');

    }
}